export default __webpack_public_path__ + "static/1178-4d073561038481e005aaf1aebe94fc99.gif";